<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-12">
        <div class="card mt-2">
          <div class="card-header mb-0">
            <h5>{{ $t("content.amnexportitemoverdue") }}</h5>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-lg-3 mt-2">
                <label class="form-label ms-0">{{ $t("content.edate") }}</label>
                <VueDatePicker v-model="start_date" :format="format" auto-apply :teleport="true"
                  :max-date="new Date()" :enable-time-picker="false" month-name-format="long"
                  :clearable="false" fluid :text-input="textInputOptions" />
              </div>

              <div class="col-lg-3 mt-2">
                <label class="form-label ms-0">{{ $t("content.edate") }}</label>
                <VueDatePicker v-model="end_date" :format="format" auto-apply :teleport="true"
                  :max-date="new Date()" :enable-time-picker="false" month-name-format="long"
                  :clearable="false" fluid  :text-input="textInputOptions" />
              </div>

              <div class="col-auto mt-2">
                <label class="form-label ms-0 png"></label>
                <material-button id="cardSearch" color="primary" class="mb-3" :disabled="start_date > end_date"
                  @click="loadDataReportApi">
                  <i class="material-icons material-symbols-outlined">search</i>
                  {{ $t("buttons.sear") }}
                </material-button>
              </div>
              <div class="col-auto mt-2">
                <label class="form-label ms-0 png"></label>
                <material-button id="cancSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                  @click="cancelBtn">
                  <i class="material-icons material-symbols-outlined">close</i>
                  {{ $t("buttons.canc") }}
                </material-button>
              </div>
            </div>
            <hr />
            <div class="row mt-3">
              <div class="table-responsive">
                <table class="table table-flush">
                  <thead class="thead-light">
                    <tr>
                      <th>#</th>
                      <th>{{ $t("content.types") }}</th>
                      <th>{{ $t("content.amnpawnval") }}</th>
                      <th>{{ $t("content.proportion") }}</th>
                      <th>{{ $t("content.amtype") }}</th>
                      <th>{{ $t("content.amitem") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- แถวข้อมูลปกติ -->
                    <tr v-for="(row, index) in listsum" :key="index">
                      <td class="text-sm font-weight-normal border-0">
                        {{ formatNumberString(index + 1) }}
                      </td>
                      <td class="text-sm font-weight-normal border-0">
                        {{ row.mainCatName }}
                      </td>
                      <td class="text-sm font-weight-normal border-0">
                        {{ formatNumberDecimalString(row.pawnValue) }}
                      </td>
                      <td class="text-sm font-weight-normal border-0">
                        {{ formatNumberDecimalString(row.proportion) }} %
                      </td>
                      <td class="text-sm font-weight-normal border-0">
                        {{ formatNumberString(row.amount) }}
                      </td>
                      <td class="text-sm font-weight-normal border-0">
                        {{ formatNumberString(row.quantity) }}
                      </td>
                    </tr>

                    <tr style="height: 20px;"  v-if="listsum.length > 0"><td colspan="6" class="border-0"></td></tr>
                    <tr class="bg-light font-weight-bold"  v-if="listsum.length > 0">
                      <td colspan="2" class="text-sm border-0" style="color:black;font-weight: bold;">{{ $t("content.ttoverdueitem") }}</td>
                      <td class="text-sm border-0">{{ formatNumberDecimalString(totalPawnValue) }}</td>
                      <td class="text-sm border-0">100.00 %</td>
                      <td class="text-sm border-0">{{ formatNumberString(totalAmount) }}</td>
                      <td class="text-sm border-0">{{ formatNumberString(totalQuantity) }}</td>
                    </tr>

                    <tr class="bg-light font-weight-bold" v-if="listsum.length > 0">
                      <td colspan="2" class="text-sm border-0" style="color:black;font-weight: bold;">{{ $t("content.allpawntotal") }}</td>
                      <td colspan="3" class="text-sm border-0" style="color:blue;font-size: 16px;font-weight: bold;">{{ formatNumberDecimalString(totalPawnValueH) }}</td>
                      <td class="text-sm border-0"  style="color:blue;font-size: 16px;font-weight: bold;">{{ formatNumberString(totalQuantityH) }}</td>
                    </tr>

                    <tr class="bg-light font-weight-bold" v-if="listsum.length > 0">
                      <td colspan="2" class="text-sm border-0" style="color:black;font-weight: bold;">% {{ $t("content.status_breaking") }}</td>
                      <td colspan="4" class="text-sm border-0">{{ formatNumberDecimalString(lostPercentRef) }} %</td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script setup>
/* eslint-disable no-unused-vars */
import { reactive, inject, computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import MaterialButton from "@/components/MaterialButton.vue";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'

import { useBreakingStore } from '@/stores/breaking';
import { useShopCatOrderStore } from '@/stores/shopcatorder'
import { useCategoryStore } from '@/stores/category'
import { useWorkCaseStore } from '@/stores/workcase'



const storecat = useCategoryStore()
const storeshcat = useShopCatOrderStore()
const storebreak = useBreakingStore()
const storew = useWorkCaseStore()

const { t } = useI18n();
const swal = inject("$swal");
const listsum = ref([]);
const listcat_all = ref([]);
const listcat_order = ref([]);
const listcat_ordernew = ref([]);
const listcat = ref([]);
const start_date = ref(new Date());
const end_date = ref(new Date());

const totalAmount = ref(0);
const totalQuantity = ref(0);
const totalPawnValue = ref(0);

const totalQuantityH = ref(0);
const totalPawnValueH = ref(0);

const lostPercentRef = ref(0);


const key = JSON.parse(localStorage.getItem("shop_seleted"));


const format = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY');
}

const textInputOptions = {
  format: 'dd/MM/yyyy'
};

const loadDataAllCatApi = async () => {
  // await new Promise((res) => setTimeout(res, 500));
  let data = "";
  data = {
    uid: "",
  };
  const payload = data;
  // const response = await store.dispatch("categorylistPrintFetch", payload);
  const response = await storecat.categorylistPrintFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listcat_all.value = response.data.data;
        await loadDataOrderCatApi()
      }
    }
  }
}

const loadDataOrderCatApi = async () => {
  listcat_ordernew.value = []
  listcat_order.value = []
  let data = "";
  let list = []
  data = {
    index: 0,
    size: '100',
    shopUid: key.uid
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storeshcat.shopCatOrderListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
          list = response.data.data.list;
          listcat.value = list
          
      }
    }
  }
}


loadDataAllCatApi()


const loadDataReportApi = async () => {
  totalAmount.value = 0
  totalQuantity.value = 0
  totalPawnValue.value = 0
  lostPercentRef.value = 0
  listsum.value = []
  let data = "";

  data = {
    groupUid: key.groupUid,
    shopUid: key.uid,
    fromDate: moment(new Date(start_date.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_date.value)).format('YYYY-MM-DDT23:59:59')
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storebreak.summaryBreakingFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        if (response.data.data.list.length > 0) { 
          let list = response.data.data.list
          totalAmount.value = response.data.data.ext.totalAmount;
          totalQuantity.value = response.data.data.ext.totalQuantity;
          totalPawnValue.value = response.data.data.ext.totalPawnValue;
          await getHistoryInfo()
          listsum.value = await calculateListSum(list);
          lostPercentRef.value = totalPawnValueH.value > 0 
          ? (totalPawnValue.value / totalPawnValueH.value) * 100 
          : 0;
        }  
      }
    }
  }
}


async function getHistoryInfo() {
  totalQuantityH.value = 0
  totalPawnValueH.value = 0
  let list = []
  let data = "";
  data = {
    index: 0,
    size: 1,
    cusUid: '',
    groupUid: key.groupUid,
    refNumber: '',
    shopUid: key.uid,
    fromDate: moment(new Date(start_date.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_date.value)).format('YYYY-MM-DDT23:59:59'),
    type: '',
    serialNumber: '',
    status: '',
    txFilter: '',
    migrateRefNumber: '',
    stockNumber: '',
    active: 'NONE',
    idCardVerify: 'NONE',
    otp: 'NONE',
    shopRepresent:'NONE',
    outage: 'NONE',
    postpone: 'NONE',
  };
  const payload = data;
  // console.log('wcs p : ' + JSON.stringify(payload));
  const response = await storew.workCaseHistoryFetch(payload);
  // console.log('wcs r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        list = response.data.data.list
        totalQuantityH.value = response.data.data.ext.quantity;
        totalPawnValueH.value = response.data.data.ext.pawnValue;
      }
    }
  }
}


// สมมติว่าคำนวณไว้ใน computed หรือ watcher
const calculateListSum  = async (list) => {
  const masterData = listcat_all.value;
  const orders = listcat.value[0]?.catOrders || {};
  const list1 = list || []; 

  // 1.หายอดรวมทั้งหมดเพื่อคิด %
  const totalValue = list1.reduce((sum, item) => sum + (item.pawnValue || 0), 0);

  // 2. เรียงลำดับตาม catOrders (1, 2, 3...)
  const sortedUids = Object.keys(orders)
    .sort((a, b) => parseInt(a) - parseInt(b))
    .map(key => orders[key]);

  // 3. สร้างข้อมูลสำหรับแต่ละแถวในตาราง
  return sortedUids.map(uid => {
    const master = masterData.find(m => m.uid === uid);
    const record = list1.find(item => 
      item.mainCatCode?.toString().trim() === master?.code?.toString().trim()
    );

    const pawnValue = record ? record.pawnValue : 0;
    // คำนวณ % (สัดส่วน)
    const proportion = totalValue > 0 ? (pawnValue / totalValue) * 100 : 0;

    return {
      mainCatName: master?.name || '',
      pawnValue: pawnValue,
      proportion: proportion, // เก็บเป็นตัวเลขเพื่อไป format ต่อ
      amount: record ? record.amount : 0,
      quantity: record ? record.quantity : 0
    };
  });
};


function cancelBtn() { 
  start_date.value = new Date();
  end_date.value = new Date();
  listsum.value = []
  totalAmount.value = 0
  totalQuantity.value = 0
  totalPawnValue.value = 0
  lostPercentRef.value = 0
  totalQuantityH.value = 0
  totalPawnValueH.value = 0
}

function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}


function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}



</script>
  
<style lang="scss" scoped>

</style>